import React, {FC, useEffect, useState} from "react";
import VersionModal from "view/VersionModal/VersionModal";
import {useSnackbar} from "notistack";
import {setSnackbarRef} from "tools/snackbar";
import SessionChanged from "view/SessionChanged";
import {SESSION_CHANGED_PATH} from "view/routes";
import Apps from "./apps";
import BackgroundTaskModal from "./BackgroundTaskModal/BackgroundTaskModal";
import NetworkStatusMonitor from "./NetworkStatusMonitor/NetworkStatusMonitor";
import {NotificationContext} from "./context/NotificationContext";

const SnackbarConfigurator: FC = () => {
  const {enqueueSnackbar} = useSnackbar();
  useEffect(() => {
    setSnackbarRef(enqueueSnackbar);
  }, [enqueueSnackbar]);
  return null;
};

const App: FC = () => {
  const [exhibitorsNumber, setExhibitorsNumber] = useState<number>();
  const [productInfo, setProductInfo] = useState<{
    productName: string;
    cartPath: string;
  }>({productName: "", cartPath: ""});

  // The session-changed notice is rendered for tabs whose session was
  // invalidated by another tab. It must not mount Apps (which subscribes to
  // Firebase auth and fires `apiV2.user.getMe()` on the new session) — that
  // would re-introduce the cross-tab cascade we are trying to avoid.
  if (window.location.pathname === SESSION_CHANGED_PATH) {
    return <SessionChanged />;
  }

  return (
    <div style={{backgroundColor: "#F8F9FA"}} id="main">
      <NotificationContext.Provider
        value={{
          exhibitorsNumber,
          productInfo: {
            productName: productInfo?.productName,
            cartPath: productInfo?.cartPath,
          },
          setExhibitorsNumber,
          setProductInfo,
        }}
      >
        <SnackbarConfigurator />
        <NetworkStatusMonitor />
        <VersionModal />
        <BackgroundTaskModal />
        <Apps />
      </NotificationContext.Provider>
    </div>
  );
};

export default App;
